import { useMemo } from "react";

import useStore from "../../../store";

import { QuestionWithAnswers } from "../types/ReportFormTypes";

/**
 * Returns the question draft answers if any
 */
export default function useDraftAnswer(question: QuestionWithAnswers) {
  const viewer = useStore((state) => state.viewer);

  return useMemo(
    () =>
      question.answers.find(
        (answer) => answer.isDraft && viewer.id === answer.userId
      ),
    [question]
  );
}
